import { Navigate } from 'react-router-dom';
import { SimpleDialog } from 'src/components/modal';
import { PATHS } from 'src/constants/paths';
import { lang, useUserRole } from 'src/utils';

import { StepperContainer } from './AddVariationTemplatePage.styled';
import { useAddVariationTemplatePage } from './hooks/AddVariationTemplatePage.hook';
import { VariationTemplateMappingStep } from './modules/variationTemplateMappingStep/VariationTemplateMappingStep';
import { TemplateListCards } from './TemplateListCards';

export const AddVariationTemplatePage = () => {
  const { isViewOnly } = useUserRole();
  const {
    activeStep,
    discardModal,
    handleDiscard,
    handleDiscardConfirm,
    handleNext,
    handleTemplateClick,
    handleVariationTemplateNext,
    isLoading,
    isSaving,
    selectedTemplate,
    setVariationMap,
    templates,
    variationMap,
  } = useAddVariationTemplatePage();

  const steps = [
    {
      component: (
        <TemplateListCards
          isLoading={isLoading}
          templates={templates}
          selectedTemplate={selectedTemplate}
          handleTemplateClick={handleTemplateClick}
          handleDiscard={handleDiscard}
          handleNext={handleNext}
        />
      ),
    },
    {
      component: (
        <VariationTemplateMappingStep
          template={selectedTemplate!}
          variationMap={variationMap}
          setVariationMap={setVariationMap}
          onDiscard={handleDiscard}
          onNext={handleVariationTemplateNext}
          isSaving={isSaving}
        />
      ),
    },
  ];

  return isViewOnly ? (
    <Navigate to={PATHS.NOT_FOUND} replace />
  ) : (
    <StepperContainer>
      {activeStep < steps.length && steps[activeStep].component}

      {discardModal.open && (
        <SimpleDialog
          modalSize="sm"
          open={discardModal.open}
          onClose={discardModal.onCloseModal}
          onClickCancel={handleDiscardConfirm}
          onClickConfirm={discardModal.onCloseModal}
          title={lang.cancelDySetupModal.title}
          subTitle={lang.cancelDySetupModal.subTitle}
          cancelText={lang.navigateBlockerModal.confirmText}
          confirmText={lang.navigateBlockerModal.cancelText}
        />
      )}
    </StepperContainer>
  );
};
